import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import {
  ChangeFormPermissionsCommand,
  DescriptiveFormTemplate,
  FormSetActiveCommandAPI,
  FormTemplate,
  PermissionInfo,
  UpdateFormFileCommand,
} from "./forms.model";
import { HttpClient } from "@angular/common/http";
import { API_URL } from "../../environments/environment";
import { DatabaseService } from "../shared/database.service";

@Injectable({
  providedIn: "root",
})
export class FormsAPIService {
  private databaseService = inject(DatabaseService);
  private http = inject(HttpClient);

  findByUuid(formUuid: string): Observable<FormTemplate> {
    return this.http.get<FormTemplate>(API_URL + "form/" + formUuid);
  }

  formUpdatePdfTemplate(cmd: UpdateFormFileCommand) {
    return this.http.post<any>(API_URL + "form/update-form-file", cmd, {
      observe: "response",
    });
  }

  formUpdateActive(cmd: FormSetActiveCommandAPI) {
    return this.http.post<any>(API_URL + "form/setactive", cmd, {
      observe: "response",
    });
  }

  formUpdatePermissions(cmd: ChangeFormPermissionsCommand) {
    return this.http.post<any>(API_URL + "form/permissions", cmd, {
      observe: "response",
    });
  }

  formGetPermissions(formUuid: string) {
    return this.http.get<PermissionInfo>(
      API_URL + "form/permissions/" + formUuid,
    );
  }

  getAll() {
    return this.databaseService.loadDescriptiveForms();
  }

  getAllDescriptive(): Observable<DescriptiveFormTemplate[]> {
    return this.http.get<DescriptiveFormTemplate[]>(API_URL + "form/short");
  }
}
